















import app from "@/app";
import { SXCompany } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCompanyMenu extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;

	get companyMenu() {
		let id = this.company.id;
		const menuDefault = [
				{
					title: "SX_LANG_SURVEYS",
					icon: "fa-question",
					link: `/companies/${id}/surveys`
				},
				{
					title: "SX_LANG_ABOUT",
					icon: "fa-info",
					link: `/companies/${id}/about`
				}
			],
			menuAdmin = [
				{
					title: "SX_LANG_SURVEY_ADD",
					icon: "fa-plus",
					link: `/companies/${id}/surveys-add`
				},
				{
					title: "SX_LANG_COMPANY_EDIT",
					icon: "fa-edit",
					link: `/companies/${id}/edit`
				},
				{
					title: "SX_LANG_COMPANY_PIC_EDIT",
					icon: "fa-image",
					link: `/companies/${id}/pic-edit`
				}
			];

		if (this.isCompanyAdmin) {
			return [menuDefault, menuAdmin];
		}

		return [menuDefault];
	}
	get isCompanyAdmin() {
		return app.services.users.isCompanyAdmin(this.company.id);
	}

	get customUrl() {
		let x = this;
		return (
			this.company &&
			app.services.urls.select(undefined, function(item) {
				return item.target === `sx_companies_${x.company!.id}`;
			})[0]
		);
	}

	deleteCompany() {
		let ok = confirm(
			app.i18n.toHuman("SX_LANG_DELETE_CONFIRM", {
				name: this.company.name
			})
		);
		if (ok) {
			this.$services.companies.deleteItem(
				this.company,
				function() {
					app.router.goBack();
					app.view.dialog({
						type: "error",
						text: "SX_LANG_COMPANY_DELETE_SUCCESS"
					});
				},
				function() {
					app.view.dialog({
						type: "error",
						text: "SX_LANG_COMPANY_DELETE_ERROR"
					});
				},
				true
			);
		}
	}
}
